var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrazing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M58.6335 32C58.6335 46.7081 46.7081 58.6335 32 58.6335C17.2919 58.6335 5.36646 46.7081 5.36646 32C5.36646 17.2919 17.2919 5.36646 32 5.36646C46.7081 5.36646 58.6335 17.2919 58.6335 32ZM32 64C49.6747 64 64 49.6747 64 32C64 14.3253 49.6747 0 32 0C14.3253 0 0 14.3253 0 32C0 49.6747 14.3253 64 32 64Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48.3052 26.3978L52.9282 19.6326L48.0181 16.2832L45.1693 20.4571H18.8375L15.9887 16.2832L11.0786 19.6326L15.7016 26.3978H48.3052ZM38.0213 32.5372L38.0802 33.4132C38.2937 36.4755 36.3282 39.4422 35.7172 40.2814C35.0547 41.1942 34.7087 42.2763 34.7087 43.41V48.9237H29.8649V43.41C29.8649 42.2689 29.5116 41.1868 28.8564 40.274C28.2528 39.4348 26.2873 36.4682 26.4934 33.4058L26.5523 32.5298L23.7623 27.4946L13.8686 30.6011L15.65 36.2768L20.5527 34.7382C20.8177 38.7502 22.8495 42.0996 23.9095 43.6014V49.5199C23.9095 52.4718 26.3094 54.879 29.2686 54.879H35.2903C38.2422 54.879 40.6494 52.4792 40.6494 49.5199V43.6014C41.7094 42.0996 43.7411 38.7428 44.0061 34.7382L48.9088 36.2768L50.6903 30.6011L40.7966 27.4946L38.0066 32.5298L38.0213 32.5372Z",
    fill: "#282828"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrazing);
export default __webpack_public_path__ + "static/media/grazing.2f8d5a55baf86de9a8a71fc72cb28f99.svg";
export { ForwardRef as ReactComponent };